// export const API_HOSTNAME = "http://localhost:8081/api";
export const API_HOSTNAME =
  process.env.NODE_ENV === "production"
    ? "https://partners.ecom360.club/api"
    : "http://localhost:8081/api";
// process.env.NODE_ENV === "production"
//   ? "https://partners.ecom360.club/api"
//   : "http://localhost:8081/api";
//   "http://localhost:8081/api";
// //https://staging.zecpe.com/api
// //https://partners.ecom360.club/api
